<ds-input [invalid]="!!(formControl.touched && formControl.errors)">
  <input
    dsInputField
    [formControl]="innerModel"
    [formlyAttributes]="field"
    [attr.data-id]="field.key"
    autocomplete="off"
    placeholder="MM/DD/YYYY"
    mask="M0/d0/0000"
  />
</ds-input>
